export default "__VITE_PUBLIC_ASSET__91aa7520__"